
import { Options } from "vue-class-component";

import { List } from "vant";

import BaseList from "@/common/BaseList";
import AppUtil from "@/util/AppUtil";
import UserVo from "@/vo/UserVo";

@Options({
  components: {
    [List.name]: List,
  },
})
/**贵宾卡套餐 */
export default class PackageList extends BaseList {
  reqUrl = "/zhShareholder/shareholder/getPackageList";
  _title = "贵宾卡明细";
  backcolor="white"
   init_item(val: any) {
    val.thumb = AppUtil.get_thumb(val.packageLogo, 180, 210);
    if (val.limitNum < 0) {
      val.limitNum = "不限购";
    }
    return val;
  }
  /**跳转套餐详情 */
  item_click(item: any) {
    this.$router.push({
      path: "/package/Detail",
      query: {
        id: item.id,
        type: 1,
        sid:UserVo.getInstance().id
      },
    });
  }
  /**分享明细 */
  detail_click(item: any) {
    this.$router.push({
      path: "/shareholder/shares",
      query: {
        id: item.id,
        surplusReceiveNum: item.surplusReceiveNum || 0,
        forwardNum: item.forwardNum || 0,
        clickNum: item.clickNum || 0,
      },
    });
  }
}
